import { useState } from 'react';
import { displayImageUrl } from '../../utils/images';

export default function StoneVisual({ stone, size = 280 }) {
  const [err, setErr] = useState(false);
  const src = displayImageUrl(stone);

  if (src && !err) {
    return (
      <img
        src={src}
        alt={stone.name}
        onError={() => setErr(true)}
        style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
      />
    );
  }

  // Fallback: coloured gradient with initial
  return (
    <div style={{
      width: size, height: size,
      background: `linear-gradient(135deg, ${stone.color}cc, ${stone.bg})`,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <span style={{
        color: 'rgba(255,255,255,0.5)',
        fontSize: size * 0.18,
        fontFamily: 'Playfair Display',
        fontStyle: 'italic',
      }}>
        {stone.type[0]}
      </span>
    </div>
  );
}
